program Offgrid;

uses
  WEBLib.Forms,
  Offgrids in 'Offgrids.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm1, Form1);
  Application.Run;
end.
